import { useMutation } from '@apollo/client';
import { loader } from 'graphql.macro';

const addTaskMutationFile = loader('./addTask.graphql');

const editTaskMutationFile = loader('./editTask.graphql');
const addTaskAssigneeMutationFile = loader('./addTaskAssignee.graphql');
const removeTaskAssigneeMutationFile = loader('./removeTaskAssignee.graphql');
const deleteTaskMutationFile = loader('./deleteTask.graphql');

export const useTaskMutations = () => {
  const [addTaskMutation] = useMutation(addTaskMutationFile, {
    refetchQueries: ['GetTasks'],
  });
  const [editTaskMutation] = useMutation(editTaskMutationFile, {
    refetchQueries: ['GetTasks'],
  });
  const [addTaskAssigneeMutation] = useMutation(addTaskAssigneeMutationFile);
  const [removeTaskAssigneeMutation] = useMutation(
    removeTaskAssigneeMutationFile,
  );
  const [deleteTaskMutation] = useMutation(deleteTaskMutationFile);

  const addTask = async ({
    title,
    taskType,
    workspaceId,
    interval,
    recurrencePattern,
    customDays,
    templateId,
    assigneeIds,
    roleIds,
    scheduledStartDate,
    scheduledEndDate,
    dueDate,
    onComplete = () => {},
    type,
    subtype,
    target,
  }) => {
    const result = await addTaskMutation({
      variables: {
        title,
        taskType,
        workspaceId,
        interval,
        recurrencePattern,
        customDays: customDays ? parseInt(customDays) : undefined,
        templateId,
        assigneeIds,
        roleIds,
        scheduledStartDate,
        scheduledEndDate,
        dueDate,
        type,
        subtype,
        target,
      },
    });
    await onComplete();
    return result?.data?.addTask;
  };

  const editTask = async ({
    id,
    title,
    interval,
    recurrencePattern,
    customDays,
    templateId,
    vehicleIds,
    roleIds,
    scheduledStartDate,
    scheduledEndDate,
    dueDate,
    onComplete = () => {},
    target,
  }) => {
    await editTaskMutation({
      variables: {
        id,
        title,
        interval,
        recurrencePattern,
        customDays: customDays ? parseInt(customDays) : undefined,
        templateId,
        vehicleIds,
        roleIds,
        scheduledStartDate,
        scheduledEndDate,
        dueDate,
        target,
      },
    }).then(() => onComplete());
  };
  const addTaskAssignee = async ({
    taskId,
    vehicleId,
    userId,
    onComplete = () => {},
  }) => {
    const taskAssignee = await addTaskAssigneeMutation({
      variables: {
        taskId,
        vehicleId,
        userId,
      },
    }).then(() => {
      onComplete();
    });
    return taskAssignee;
  };
  const removeTaskAssignee = async ({ id, userId }) => {
    await removeTaskAssigneeMutation({ variables: { id, userId } });
  };

  const deleteTask = async ({ id }) => {
    deleteTaskMutation({ variables: { id } });
  };

  return { addTask, editTask, addTaskAssignee, removeTaskAssignee, deleteTask };
};
